module.exports = __webpack_public_path__ + "img/house_06.9217f8be.jpg";